<template>
    <div :class="passwordClass"></div>
</template>

<script>
import zxcvbn from "zxcvbn";
import nameScore from "@/utils/passwordStrengthName";

export default {
    props: {
        password: String,
    },
    computed: {
        passwordClass() {
            if (!this.password) {
                return null;
            }
            const score = zxcvbn(this.password).score;
            const strength = nameScore(score);
            return { [strength]: true };
        },
    },
};
</script>
